import mapboxgl, { LngLat } from 'mapbox-gl';
import { Position } from 'geojson';

export const getAltitude = (coordinate: Position, map: mapboxgl.Map) => {
  const lngLat = new LngLat(coordinate[0], coordinate[1]);
  return map.queryTerrainElevation(lngLat, { exaggerated: true });
};
